import { Chip } from "@mui/material";
import { t } from "i18next";

interface DeliveryStatusBadgeProps {
  status?: string | null;
}

const DeliveryStatusBadge = (props: DeliveryStatusBadgeProps) => {
  const { status } = props;

  if (!status) {
    return <span>-</span>;
  }

  const statusColor = getStatusColor(status);

  return (
    <Chip
      label={t(status)}
      color={statusColor as any}
      variant="filled"
      size="small"
    />
  );
};

const getStatusColor = (
  status: string,
): "default" | "primary" | "success" | "warning" | "error" => {
  const lowerStatus = status.toLowerCase();

  if (lowerStatus.includes("completed") || lowerStatus.includes("done")) {
    return "success";
  }
  if (lowerStatus.includes("pending") || lowerStatus.includes("open")) {
    return "warning";
  }
  if (lowerStatus.includes("canceled") || lowerStatus.includes("failed")) {
    return "error";
  }
  if (lowerStatus.includes("in progress")) {
    return "primary";
  }

  return "default";
};

export default DeliveryStatusBadge;
